<template>
  <router-view v-slot="{ Component }">
    <transition name="view" appear>
      <div class="mobile">
        <component :is="Component" />
      </div>
    </transition>
  </router-view>
</template>

<script>
import { TEMPLATE_MOBILE } from '@/utils/constants';
import { mapMutations, mapGetters, mapActions, mapState } from 'vuex';
export default {
  name: 'Mobile',
  data: function () {
    return {};
  },
  components: {
    // MobileComp
  },
  computed: {
    ...mapGetters('globalState/settings', ['getDurationTime']),
    ...mapState('mobileState/mobileCommonState', ['mobileServices']),
  },
  methods: {
    ...mapMutations('globalState/app', ['setTemplate']),
    ...mapMutations('mobileState/mobileCommonState', ['setMobileTab']),
    ...mapActions('mobileState/mobileCommonState', ['selectMobileService']),
  },
  async mounted() {
    this.setTemplate(TEMPLATE_MOBILE);
  },
};
</script>

<style lang="scss" scoped>
.mobile {
  width: 100%;
  height: 100%;
  min-height: calc(95vh - (3.5438em + 2.625em));
}
</style>
